<script>
import { profileMethods, profileComputed } from "@/state/helpers";
import { Storage } from 'aws-amplify';

export default {
    data() {
        return {
            logoSrc: null
        }
    },
    computed: {
        ...profileComputed
    },
    methods: {
        ...profileMethods,
        formatTime(time) 
        {
            // Add AM or PM to the time value if it's in 12-hour format
            if(time != null && time != '')
            {
                const timeParts = time.split(':');
                let hour = parseInt(timeParts[0]);
                const minute = timeParts[1];

                const isAM = hour < 12;
                if (hour === 0) {
                    hour = 12; // 12:00 AM should be displayed as 12:00 AM, not 00:00 AM
                } else if (hour > 12) {
                    hour -= 12;
                }

                const period = isAM ? 'AM' : 'PM';
                return `${hour}:${minute} ${period}`;
            }
            return `--`;
            
        },
    },
    async created() {
        await this.fetchUserProfile();
        this.logoSrc = this.userData.org.logoKey != null && this.userData.org.logoKey != '' ? await Storage.get(this.userData.org.logoKey, { level: "public" }) : require('@/assets/images/img-placeholder.png');
        this.$emit('profile-src-loaded', this.userData.user.profile);
    
    }
}
</script>

<template>
    <div>
        <div class="row">
            <h5 class="mb-4"><b>Users Details</b></h5>
            <div class="col-sm-6">
                <div class="form-group">
                    <label class="label-color">Full Name</label>
                    <p>{{ userData.user.name ?? '' }}</p>
                </div>
            </div>
            <div class="col-sm-6">
                <div class="form-group">
                    <label class="label-color">Roles</label>
                    <p>{{ userData.user.roleName }}</p>
                </div>
            </div>
        </div>
        <hr>
        <div class="row">
            <h5 class="mb-4"><b>Contact Info</b></h5>
            <div class="col-sm-6">
                <div class="form-group">
                    <label class="label-color">Mobile Number</label>
                    <p>{{ userData.user.mobile }}</p>
                </div>
            </div>
            <div class="col-sm-6">
                <div class="form-group">
                    <label class="label-color">Email Address</label>
                    <p>{{ userData.user.email  }}</p>
                </div>
            </div>
        </div>
         <div class="row mt-2">
            <h5 class="mb-4"><b>Business Details</b></h5>
            <div class="col-sm-6">
                <div class="row">
                    <div class="form-group">
                        <label class="label-color">Business Type</label>
                        <p>{{ userData.org.type != null && userData.org.type.length != 0 ?  userData.org.type : '--' }}</p>
                    </div>
                </div>
                <div class="row">
                    <div class="form-group">
                        <label class="label-color">Business Name</label>
                        <p>{{ userData.org.name }}</p>
                    </div>
                </div>
            </div>
            <div class="col-sm-6">
                <div class="form-group">
                    <label class="label-color">Business Logo</label>
                </div>
                <img :src="logoSrc" alt="" class="logo-img" />
            </div>
            <div class="col-sm-6">
                <div class="form-group">
                    <label class="label-color">Business Hours</label>
                    <p>{{ formatTime(userData.org.startHour) }} - {{ formatTime(userData.org.endHour) }}</p>
                </div>
            </div>
            <div class="col-sm-6">
                <div class="form-group">
                    <label class="label-color">Business Mobile Number</label>
                    <p>{{ userData.org.contactNumber != '' ? (userData.org.contactNumber ?? '--') :  '--' }}</p>
                </div>
            </div>
        </div>
        <div class="row mt-2">
            <h5 class="mb-4"><b>Business Address</b></h5>
            <div class="col-sm-6">
                <div class="form-group">
                    <label class="label-color">Country</label>
                    <p>{{ userData.org.country ?? '--' }}</p>
                </div>
            </div>
            <div class="col-sm-6">
                <div class="form-group">
                    <label class="label-color">Region</label>
                    <p>{{ userData.org.region ?? '--' }}</p>
                </div>
            </div>
            <div class="col-sm-6">
                <div class="form-group">
                    <label class="label-color">State / Province</label>
                    <p>{{ userData.org.province ?? '--'  }}</p>
                </div>
            </div>
            <div class="col-sm-6">
                <div class="form-group">
                    <label class="label-color">Barangay</label>
                    <p>{{ userData.org.barangay ?? '--' }}</p>
                </div>
            </div>
            <div class="col-sm-6">
                <div class="form-group">
                    <label class="label-color">Building No. / Street Name / District</label>
                    <p>{{ userData.org.street ?? '--' }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
.label-color{
    color: #AFAFAF;
}
.logo-img {
    width: 250px;
    height: 80px;
    padding: 8px;
    background: #f2f1f7;
    border-radius: 10px;
    object-fit: contain;

}

.card {
  display: flex;
}

</style>